import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import syringe from '../assets/icons/syringe.png';

function GoTopButton() {
  const [drops, setDrops] = useState([]);

  const handleScrollTop = () => {
    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    // Add multiple drops for animation
    const newDrops = Array.from({ length: 15 }, () => ({
      id: Date.now() + Math.random(), // Unique ID for each drop
      x: Math.random() * 60 - 30, // Random horizontal spread
      y: Math.random() * -60 - 20, // Random upward spread
    }));
    setDrops((prevDrops) => [...prevDrops, ...newDrops]);

    // Remove drops after animation ends (1s duration)
    setTimeout(() => {
      setDrops((prevDrops) => prevDrops.filter((drop) => !newDrops
        .some((newDrop) => newDrop.id === drop.id)));
    }, 1000);
  };
  return (
    <div className="go-top-container">
      <button
        onClick={handleScrollTop}
        type="button"
        id="goTop-btn"
        className="go-top-btn"
      >
        <img src={syringe} alt="Scroll to top" />
      </button>

      {/* Render drops */}
      <AnimatePresence>
        {drops.map((drop) => (
          <motion.div
            key={drop.id}
            className="drop"
            initial={{
              opacity: 1, x: 0, y: -70, scale: 1,
            }}
            animate={{
              opacity: 1, x: drop.x, y: drop.y - 60, scale: 0.5,
            }}
            exit={{ opacity: 1 }}
            transition={{ duration: 1 }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
}

export default GoTopButton;
